'use client'

interface CometFooterProps {
  ctaLabel?: string
  ctaHref?: string
  headline?: string
}

export function CometFooter({
  ctaLabel = 'REQUEST A DEMO',
  ctaHref = 'https://comethealth.ai/request-a-demo',
  headline = 'Fuel Access Center Performance with the Power of Comet',
}: CometFooterProps) {
  return (
    <footer className="comet-footer">
      {/* Green glow + vignette are baked into the background PNG (live-site approach) */}
      <div className="comet-footer__body">
        <p className="comet-footer__headline">{headline}</p>
        <a href={ctaHref} className="comet-footer__cta">
          <span className="comet-footer__cta-text">
            <span className="btn-primary-text">{ctaLabel}</span>
            <span className="btn-hover-text">{ctaLabel}</span>
          </span>
        </a>
      </div>

      {/* Bottom bar — logo left, links right, margin-top 120px */}
      <div className="comet-footer__bar">
        <a href="https://comethealth.ai" className="comet-footer__bar-logo" aria-label="Comet by Innovaccer">
          <img
            src="/media/product-icons/comet-footer-logo.png"
            alt=""
            aria-hidden="true"
            draggable={false}
          />
        </a>
        <div className="comet-footer__links">
          <span>Comet<sup>TM</sup></span>
          <a href="https://comethealth.ai/terms-of-use">Terms</a>
          <a href="https://comethealth.ai/privacy">Privacy</a>
          <a href="https://comethealth.ai/pilot-program">Free Pilot Program</a>
        </div>
      </div>
    </footer>
  )
}

export default CometFooter
